import { render } from "./IconAdd.vue?vue&type=template&id=653a31ce"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconAdd.vue"]])

export default __exports__